import { atom } from 'recoil';

const questionWithOpenedImagePreviewAtom = atom({
    key: 'projectManager_projectDataManagement_questionWithOpenedImagePreview',
    default: null,
});

export default questionWithOpenedImagePreviewAtom;
